import { Component, Inject, Optional, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import SignaturePad from 'signature_pad';
import { PreAssessmentService } from '../../services/api-services/pre-assessments.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-add-sign',
  templateUrl: './add-sign.component.html',
  styleUrls: ['./add-sign.component.scss']
})
export class AddSign {
  warning: boolean = false;
  disableButton: boolean = false;
  savedSignature: boolean = false;
  manualSignature: string | null = null;
  consultation_programe_id: number;
  currentDate: any;
  @ViewChild('signaturePad', { static: true }) signaturePadElement!: ElementRef<HTMLCanvasElement>;
  signaturePad!: SignaturePad;

  constructor(
    public dialogRef: MatDialogRef<AddSign>,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any,
    private preAssessmentService: PreAssessmentService,
    private toastr: ToastrService
  ) {
    this.consultation_programe_id = this.props?.item?.consultation_programe_id;
    this.currentDate = this.props?.item?.date;
  }

  saveSignature() {
    if (this.signaturePad.isEmpty()) {
      this.toastr.warning('Signature pad is empty.');
      return;
    }
    this.savedSignature = true;
    const canvas = this.signaturePadElement.nativeElement;
    // Convert canvas to Blob
    canvas.toBlob((blob) => {
      if (blob) {
        const file = new File([blob], 'signature.png', { type: 'image/png' });
        // Upload if program ID is 0, 1, or 2
        if ([0, 1, 2, 4].includes(this.consultation_programe_id)) {
          this.addSignReviewPdf(file);
        }
      }
    }, 'image/png');
  }

  // Send signature file and additional data to API
  addSignReviewPdf(file: File) {
    const formData = new FormData();
    formData.append('pharmacy_sign', file);
    formData.append('response_id', this.props?.item?.response_id);
    formData.append('user_id', this.props?.item?.user_id);
    formData.append('mType', this.props?.item?.mType);

    this.preAssessmentService.addSignatureReviewPdf(formData, {}).subscribe(
      (res: any) => {
        if (res?.success) {
          this.toastr.success(res?.message);
          this.savedSignature = false;
          this.dialogRef.close(res);
        } else {
          this.toastr.error(res?.message);
          this.savedSignature = false;
          this.dialogRef.close(res);
        }
      },
      (error: any) => {
        console.error('Error:', error.message);
        this.savedSignature = false;
        this.toastr.error(error.message);
        this.dialogRef.close();
      }
    );
  }

  // Function to download the signature file
  // downloadSignature(file: File) {
  //   const link = document.createElement('a');
  //   link.href = URL.createObjectURL(file);
  //   link.download = 'signature.png';
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // }

  uploadSign() {
    // Trigger the click event of the hidden file input
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  clearSignature() {
    this.signaturePad.clear();
    this.manualSignature = null; // Clear the manually selected signature
    // Clear the file input value
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  closoPopup() {
    this.signaturePad.clear();
    this.manualSignature = ''; // Clear the manually selected signature
    this.dialogRef.close();
  }

  ngAfterViewInit() {
    this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
  }

  onFileChange(event: any) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const selectedFile: File = fileList[0];

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const imageData: string = e.target.result;

        // Resize the image and limit file size to 200 KB
        this.resizeAndLimitSize(imageData, 500, 200).then((resizedImage) => {
          this.manualSignature = resizedImage;

          // Display the resized image on the canvas
          this.displayImageOnCanvas(resizedImage);
        });
      };
      reader.readAsDataURL(selectedFile);
    }
  }

  resizeAndLimitSize(imageData: string, maxWidth: number, maxSizeKB: number): Promise<string> {
    return new Promise<string>((resolve) => {
      const img = new Image();
      img.onload = async () => {
        // Set the target width
        const targetWidth = 500;

        // Calculate the corresponding height while maintaining the aspect ratio
        const aspectRatio = img.width / img.height;
        const targetHeight = targetWidth / aspectRatio;

        // Create a temporary canvas with the target dimensions
        const canvas = document.createElement('canvas');
        canvas.width = targetWidth;
        canvas.height = targetHeight;

        const context = canvas.getContext('2d');

        if (context) {
          // Draw the image on the canvas
          context.drawImage(img, 0, 0, targetWidth, targetHeight);

          // Convert canvas content to data URL with JPEG format and desired quality
          const compressedImage = canvas.toDataURL('image/jpeg', 0.8);

          // Check if the compressed image meets the size limit
          if (compressedImage.length <= maxSizeKB * 1024) {
            resolve(compressedImage);
          } else {
            console.error('Resized and compressed image still exceeds the size limit.');
            // Reject the promise with an error message or return an empty string
            resolve('');
          }
        } else {
          console.error('Error creating canvas context.');
          // Reject the promise with an error message or return an empty string
          resolve('');
        }
      };

      img.src = imageData;
    });
  }

  // Display the selected image on the canvas
  displayImageOnCanvas(imageData: string) {
    const canvas: HTMLCanvasElement = this.signaturePadElement.nativeElement;
    const context: CanvasRenderingContext2D | null = canvas.getContext('2d');

    if (context) {
      const image = new Image();
      image.onload = () => {
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
      };
      image.src = imageData;
    }
  }

}
